<template>
    <div>
        <div class="card-header">
            {{ $t("lang.label_crop_img") }}
            <!-- <span style="margin-bottom: 0rem">{{ dataCropperTextContent }}</span> -->
            <button @click="closeModal" class="closeIcon"><span></span></button>
            <!-- {{container}} -->
        </div>
        <div class="card-body" v-if="isLoading === false">
            <div
                v-if="container === 'image-container-neutral'"
                class="image-container-neutral"
            >
                <img
                    ref="image"
                    id="imagesss"
                    :src="srcz"
                    style="display: block; max-width: 100%"
                    crossorigin
                />
            </div>
            <div
                v-if="container === 'image-container-vertical'"
                class="image-container-vertical"
            >
                <img
                    ref="image"
                    id="imagesss"
                    :src="srcz"
                    style="display: block; max-width: 100%"
                    crossorigin
                />
            </div>
            <div
                v-if="container === 'image-container-horizontal'"
                class="image-container-horizontal"
            >
                <img
                    ref="image"
                    id="imagesss"
                    :src="srcz"
                    style="display: block; max-width: 100%"
                    crossorigin
                />
            </div>
            <div class="background" v-if="srcz === '' || srcz === null"></div>
            <div v-else class="image-preview-container" style="">
                <img ref="destination" :src="destination" class="image-preview" />
            </div>
        </div>
        <div class="card-body" v-else>
            <loader></loader>
        </div>
        <input
            accept="image/png, image/jpeg"
            ref="imageFile"
            style="display: none"
            type="file"
            @change="fileportadaOriginal($event)"
        />
        <div class="card-footer" style="margin-top: 320px">
            <div class="botoneras">
                <button @click="resetCropper" class="boton reset">
                    <i class="fas fa-backspace"></i>
                </button>
                <button @click="zoomInCropper" class="boton">
                    <i class="fas fa-search-plus"></i>
                </button>
                <button @click="zoomOutCropper" class="boton">
                    <i class="fas fa-search-minus"></i>
                </button>
                <button @click="rotateLeft" class="boton">
                    <i class="fas fa-undo-alt"></i>
                </button>
                <button @click="rotateRight" class="boton">
                    <i class="fas fa-redo"></i>
                </button>
                <button @click="displayRef('imageFile')" class="boton upload">
                    <i class="fa fa-upload"></i>
                </button>
                <button @click="uploadImage()" class="boton saved" :disabled="btnDisable">
                    <i class="fas fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/shared/Loader";
import Cropper from "cropperjs";
export default {
    name: "demox",
    components: {
        Loader,
    },
    data () {
        return {
            isLoading: false,
            cropper: {},
            destination: {},
            image: {},
            srcz: "require('@/assets/pic_special3.png')",
            i: [],
            index: "",
            selectedFile: {},
            dataCropper: {},
            dataCropperTextContent: "",
            foodItems: [],
            btnDisable: false,
            event: [],
            container: "image-container-neutral",
        }
    },
    created () {
        this.init();
    },
    methods: {
        init() {
            let data = this.$store.getters["getCropperImagenes"][0].dat[0];
            // console.log(data);
            this.srcz = require("@/assets/pic_special3.png");
            this.i = data.i;
            this.index = data.index;
            this.foodItems = data.foodItems;
        },
        displayRef() {
            this.$refs["imageFile"].click();
        },
        fileportadaOriginal(event) {
            let file = event.target.files[0];
            let t = this;
            // debugger;
            let r = [];
            if (event.target.files && event.target.files[0]) {
                let reader = new FileReader();
                let image = new Image();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    image.src = reader.result;
                    t.cropper.destroy();
                    setTimeout(function () {
                        t.return(image.width, image.height, e.target.result, event);
                        // t.isLoading = false
                    }, 1000);
                };
            }
        },
        return(width, height, src, event) {
            if (width < height) {
                this.container = "image-container-vertical";
                this.srcz = require("@/assets/pic_special4.png");
            } else if (width > height) {
                this.container = "image-container-horizontal";
                this.srcz = require("@/assets/pic_special5.png");
            } else {
                this.container = "image-container-neutral";
                this.srcz = require("@/assets/pic_special6.png");
            }
            let t = this;
            setTimeout(function () {
                t.isLoading = true;
                t.montar();
                let cropperHide = document.querySelector(".cropper-hide");
                if (cropperHide !== null) {
                    document.querySelector(".cropper-hide").src = "";
                    document.querySelector(".cropper-hide").src = src;
                }
                let cropperView = document.querySelector(".cropper-view-box img");
                if (cropperView !== null) {
                    document.querySelector(".cropper-view-box img").src = "";
                    document.querySelector(".cropper-view-box img").src = src;
                }
                t.isLoading = false;
            }, 1000);
        },
        zoomInCropper() {
            this.cropper.zoom(0.1);
        },
        zoomOutCropper() {
            this.cropper.zoom(-0.1);
        },
        resetCropper() {
            this.cropper.reset();
        },
        deleteCropper() {
            this.cropper.clear();
        },
        rotateLeft() {
            this.cropper.rotate(-90);
        },
        rotateRight() {
            this.cropper.rotate(90);
        },
        closeModal() {
            this.$modal.hide("croppe");
            // var index = document.styleSheets[0].insertRule(`#li${i}:after {content: "${data[2][i]}"; }`, 0);
            var index = document.styleSheets[0];
            // document.styleSheets[0].deleteRule(index.cssRules[0]);
            // document.styleSheets[0].deleteRule(index.cssRules[1]);
            // console.log(index.cssRules);
            let cssRules = index.cssRules;
            for (let i in cssRules) {
                let css = cssRules[i];
                for (const y in css) {
                    if (y === 1) {
                        // console.log(css[y]);
                    }
                    //  console.log(cssRules[i]);
                }
            }
            // document.styleSheets[0].deleteRule(index.rules[0]);
            // document.styleSheets[0].deleteRule(index.rules[1]);
            // console.log(index.rules);
            // console.log(index);
            // document.styleSheets[0].deleteRule(index);
        },
        uploadImage() {
            this.btnDisable = true;
            this.cropper.getCroppedCanvas().toBlob((blob) => {
                let t = this;
                let data = [];
                data.push({
                    function: "uploadCrop",
                    dat: blob,
                    i: t.i,
                    index: t.index,
                    foodItems: t.foodItems,
                    event: t.destination,
                });
                this.$store.commit("setCropperImagenes", data);
                this.btnDisable = false;
            });
        },
        montar() {
            this.image = this.$refs.image;
            var minCroppedWidth = 150;
            var minCroppedHeight = 150;
            var maxCroppedWidth = 800;
            var maxCroppedHeight = 400;
            let t = this;
            this.cropper = new Cropper(this.image, {
                checkCrossOrigin: false,
                checkOrientation: false,
                scalable: true,
                aspectRatio: 1,
                viewMode: 3,
                data: {
                    width: (minCroppedWidth + maxCroppedWidth) / 2,
                    height: (minCroppedHeight + maxCroppedHeight) / 2,
                },
                crop: () => {
                    let width = event.detail.width;
                    let height = event.detail.height;
                    if (
                        width < minCroppedWidth ||
                        height < minCroppedHeight ||
                        width > maxCroppedWidth ||
                        height > maxCroppedHeight
                    ) {
                        this.cropper.setData({
                            width: Math.max(
                                minCroppedWidth,
                                Math.min(maxCroppedWidth, width)
                            ),
                            height: Math.max(
                                minCroppedHeight,
                                Math.min(maxCroppedHeight, height)
                            ),
                        });
                    }
                    this.dataCropper = this.cropper.getData(true);
                    let cam = ""; // validacion para evitar error al cambiar de resolusion
                    let doc = document.querySelector(".image-preview");
                    if (doc !== null) {
                        cam = document.querySelector(".image-preview").innerHTML;
                    }
                    cam = this.cropper.getCroppedCanvas();
                    this.dataCropperTextContent = JSON.stringify(
                        this.cropper.getData(true)
                    );
                    const canvas = this.cropper.getCroppedCanvas();
                    this.destination = canvas.toDataURL("image/png");
                },
            });
        },
    },
    mounted () {
        this.montar();
    },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/cropper_customer.css";
.image-container-neutral {
    width: 50%;
    display: block;
    position: absolute;
    left: 10px;
}
.image-container-vertical {
    width: 50%;
    display: block;
    position: absolute;
    left: 10px;
}
.image-container-horizontal {
    width: 52%;
    display: block;
    position: absolute;
    left: 10px;
}
.image-preview-container {
    display: block;
    position: absolute;
    right: 10px;
}
.image-preview {
    width: 250px;
    height: 250px;
    float: right;
}
.botoneras {
    margin-top: -11px;
    display: flex;
    justify-content: center;
    z-index: 1;
}
.botoneras .boton {
    border: 1px solid;
    padding: 5px 8px;
    margin-right: 4px;
    background: #585858;
    color: #fff;
    // font-size: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
}
.botoneras .boton.reset {
    color: #fff;
    background-color: #f92e06;
    border-color: #ec2c06;
}
.botoneras .boton.saved {
    color: #fff;
    background-color: #469f35;
    border-color: #429532;
}
.botoneras .boton.upload {
    color: #fff;
    background-color: #0065df;
    border-color: #0065df;
}
.background {
    text-align: center;
    overflow: hidden;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url("/img/pic_special.3602e569.png");
}
</style>
